
import { NavLink } from "react-router";
import UsersListComponent from "../../components/Users/UsersList";
import { useAuth } from "../../contexts/auth/useAuth";
import { roles } from "../../types/Users";
import { useTrads } from "../../contexts/trads/useTrads";


function UsersList(){
    const {hasRole} = useAuth();
    const {translate}=useTrads();
    return (
        <div>
        {hasRole(roles.Manager)?
            <NavLink to="/user/add" className="btn btn-primary mt-3">{translate('btn_add')}</NavLink>
        :null}

        <UsersListComponent filtre={{r:{}}}  />
        </div>
    );
}
export default UsersList;

